import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppState } from 'state'
import { NftItem } from 'state/nft/types'

const fetchFavoritedNft = createAsyncThunk<
  {
    items: NftItem[]
    hasMore: boolean
  },
  void,
  { state: AppState }
>('nft/getFavorites', async (_, thunkApi) => {
  const { favorites } = thunkApi.getState().nftFavorites
  const { search, orderBy, orderByAs } = thunkApi.getState().nft
  const res = await fetch(
    `${process.env.REACT_APP_NFT_STATS_API_URL}/nft/favorites?orderBy=${orderBy}&orderByAs=${orderByAs}&search=${search}`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        slugs: favorites
      })
    }
  )
  const items = await res.json()

  return { items, hasMore: false }
})

export default fetchFavoritedNft
